class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (
      this.els?.['converter-trigger']?.exists &&
      this.els?.['converter-item']?.exists
    ) {
      this.onConverterTriggerClick = this.onConverterTriggerClick.bind(this)
      this.onConverterItemClick = this.onConverterItemClick.bind(this)

      this.els['converter-trigger'].elements.forEach((el) => {
        this.listeners.add(el, 'click', this.onConverterTriggerClick)
      })

      this.els['converter-item'].elements.forEach((el) => {
        this.listeners.add(el, 'click', this.onConverterItemClick)
      })
    }
  }

  onConverterTriggerClick () {
    const triggerElement = this.els['converter-trigger'].element
    const itemsElement = this.els['converter-items'].element

    const currentTriggerState =
      triggerElement.getAttribute('aria-expanded') === 'true'
    triggerElement.setAttribute('aria-expanded', !currentTriggerState)

    const currentDrawerState =
      itemsElement.getAttribute('aria-hidden') === 'true'
    itemsElement.setAttribute('aria-hidden', !currentDrawerState)
  }

  onConverterItemClick (event) {
    const value = event.target.dataset.value
    const label = event.target.textContent

    this.els.heading.elements.forEach((el) => {
      const currentValue = el.dataset.value
      const currentObject = this.conversions.PP

      if (!currentObject) return

      const valueIndex = currentObject.findIndex(
        (el) => String(el) === String(currentValue),
      )

      const newObject = this.conversions[value]
      if (!newObject) return

      const newValue = newObject[valueIndex]
      if (!newValue) return

      if (this.sizing === 'ring') {
        el.innerHTML = newValue
      } else {
        const ppObject = this.conversions.PP
        const ppValue = ppObject[valueIndex]

        if (value !== 'PP') {
          el.innerHTML = `${newValue} | ${ppValue}`
        } else {
          el.innerHTML = newValue
        }
      }
    })

    this.els['converter-text'].element.textContent = label
    this.els['converter-trigger'].element.setAttribute(
      'aria-expanded',
      'false',
    )
    this.els['converter-items'].element.setAttribute('aria-hidden', 'true')
  }

  get conversions () {
    return this.sizing === 'ring'
      ? {
          PP: ['11', '13', '15'],
          UK: ['L 1/2', 'N', 'O 1/2'],
          US: ['5.5', '6', '7'],
          IT: ['11', '13', '15'],
          DE: ['16.5', '17', '17.5'],
          JP: ['13', '11', '15'],
          INT: ['S', 'M', 'L'],
        }
      : this.sizing === 'INT'
        ? {
            PP: ['XS', 'S', 'M', 'L', 'XL'],
            UK: ['UK 6', 'UK 8', 'UK 10/12', 'UK 14', 'UK 16'],
            US: ['US 2', 'US 4', 'US 6/8', 'US 10', 'US 12'],
            FR: ['FR 34', 'FR 36', 'FR 38/40', 'FR 42', 'FR 44'],
            IT: ['IT 38', 'IT 40', 'IT 42/44', 'IT 46', 'IT 48'],
            DE: ['DE 32', 'DE 34', 'DE 36/38', 'DE 40', 'DE 42'],
            JP: ['JP 5', 'JP 7', 'JP 9/11', 'JP 13', 'JP 15'],
            KR: ['KR 44', 'KR 55', 'KR 66/77', 'KR 88', 'KR 99'],
            AU: ['AU 6', 'AU 8', 'AU 10/12', 'AU 14', 'AU 16'],
          }
        : {
            PP: ['FR 34', 'FR 36', 'FR 38', 'FR 40', 'FR 42', 'FR 44'],
            UK: ['UK 6', 'UK 8', 'UK 10', 'UK 12', 'UK 14', 'UK 16'],
            US: ['US 2', 'US 4', 'US 6', 'US 8', 'US 10', 'US 12'],
            SML: ['S', 'S', 'M', 'M', 'L', 'L', 'XL'],
            IT: ['IT 38', 'IT 40', 'IT 42', 'IT 44', 'IT 46', 'IT 48'],
            DE: ['DE 32', 'DE 34', 'DE 36', 'DE 38', 'DE 40', 'DE 42'],
            JP: ['JP 5', 'JP 7', 'JP 9', 'JP 11', 'JP 13', 'JP 15'],
            KR: ['KR 44', 'KR 55', 'KR 66', 'KR 77', 'KR 88', 'KR 99'],
            AU: ['AU 6', 'AU 8', 'AU 10', 'AU 12', 'AU 14', 'AU 16'],
            INT: ['XS', 'S', 'M', 'M', 'L', 'XL'],
          }
  }

  get sizing () {
    return this.dataset.sizing
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
